const conversion_table = {
    'a': 1, 'i': 1, 'q': 1, 'j': 1, 'y': 1, 'á': 3,
    'í': 3, 'à': 2, 'ì': 2, 'b': 2, 'k': 2, 'r': 2,
    'c': 3, 'g': 3, 'l': 3, 's': 3, 'ã': 4, 'd': 4,
    'm': 4, 't': 4, 'e': 5, 'h': 5, 'n': 5, 'é': 7,
    'è': 1, 'u': 6, 'v': 6, 'x': 6, 'w': 6, 'ç': 6,
    'ú': 8, 'ù': 3, 'o': 7, 'z': 7, 'ó': 9, 'ò': 5,
    'õ': 1, 'â': 8, 'ô': 5, 'ê': 3, 'f': 8, 'p': 8,
    '\'': 2, 'ä': 2, 'ü': 3, 'û': 4, 'ũ': 9,
    'ï': 2, 'î': 8, 'ĩ': 4, 'ë': 1, 'ẽ': 8, 'ö': 5,
    'ý': 3, 'ỳ': 2, 'ŷ': 8, 'ỹ': 4, 'ÿ': 2, 'å': 8, 'e̊': 3,
    'ů': 4, 'ẙ': 5,'i̊': 8,'d̊': 2,'g̊': 1,'j̊': 8,'q̊': 8,
    's̊': 1,'v̊': 4,'ẘ': 4,'x̊': 4
}

const generate_pyramid = () => {
    const invertedPyramidForm = document.querySelector('form#new_inverted_pyramid');
    const fullnameField = document.querySelector('input#fullname');
    const contentBoard = document.querySelector('div.pyramid-board');
    let base_pyramid = [];
    let rendered_pyramid = '';
    let pyramid_report = '';

    invertedPyramidForm.onkeypress = handle_enter_key_submit;

    fullnameField.addEventListener('change', function() {
        let fullname = fullnameField.value;


        base_pyramid = compute_pyramid(fullname);
        rendered_pyramid = render_pyramid(base_pyramid, fullname);
        pyramid_report = render_pyramid_report(fullname);

        if(fullname === ''){
            rendered_pyramid = '';
            pyramid_report = '';
        }

        contentBoard.innerHTML = rendered_pyramid + pyramid_report;
    });
}

const compute_pyramid = (fullname) => {
    fullname = fullname.toString().replaceAll(/\s/g, '').toLowerCase().split('');

    kabbalistic_pyramid = [[]]
    fullname.forEach((char, idx, arr) => {
        kabbalistic_pyramid[0].push(sum_number(conversion_table[char]));
    })

    let lines_to_compute = fullname.length - 1;

    for (let i = 0; i < lines_to_compute; i++){
        let lastIndex = kabbalistic_pyramid.length - 1;
        let current_line = kabbalistic_pyramid[lastIndex];
        let new_line_len = 0;
        let new_line = [];

        while(new_line_len < current_line.length - 1){
            let num = current_line[new_line_len] + current_line[new_line_len+1];
            new_line.push(sum_number(num));
            new_line_len += 1;
        }

        kabbalistic_pyramid.push(new_line);
    }

    return kabbalistic_pyramid;
}

const sum_number = (num) => {
    const extract_digits = (val) => val.toString().split('').map(Number);

    let digits = extract_digits(num);
    let result = Infinity;

    while (result > 9) {
        result = digits.reduce(function(a,b){
            return a+b;
        }, 0);

        digits = extract_digits(result);
    }

    return result;
}

const render_pyramid = (pyramid, socialName) => {
    life_triangle = '';

    socialName = socialName.toString().replaceAll(/\s/g, '').toUpperCase().split('');

    spaces = 0
    pyramid.forEach((line, idx, arr) => {
        let line_as_str = '';
        line.forEach((num, idx, arr) => {
            if (idx == line.length-1) {
                line_as_str += num;
            }
            else
                line_as_str += num + "&nbsp;";
        });

        life_triangle += "<div>" + line_as_str + "</div>"
        spaces += 1
    })

    return life_triangle
}

const render_pyramid_report = (fullname) => {
    let negative_sequences = compute_negative_sequences(fullname)
    let report = '';

    if(negative_sequences.length > 0) {
        let sequences = '';
        let occurrences = {};

        report = '<table><thead><td>Atenção: Seu nome possui sequências com 3 ou mais números iguais: ';
        negative_sequences.forEach((ns, idx, arr) => {
            occurrences[ns.toString()] = count_occurrences(negative_sequences, ns);
        })
        
        Object.keys(occurrences).forEach((key, idx, arr) => {
            report += `<strong>${occurrences[key]}x${key}</strong>, `;
        })
        report += '</td></thead></table>';
    } else {
        report = '<table><thead><td>Seu nome não possui sequências negativas</td></thead></table>';
    }

    return report;
}

const count_occurrences = (arr, val) => {
    return arr.reduce((a, v) => (v === val ? a + 1 : a), 0);
}

const compute_negative_sequences = (fullname) => {
    let negative_seqs_occurrences = identify_negative_sequences_position(fullname);
    let negative_sequences = [];

    for (let line in negative_seqs_occurrences) {
        Object.keys(negative_seqs_occurrences[line]).forEach((sequence, idx, arr) => {
            for (let i = 0; i < negative_seqs_occurrences[line][sequence]["rep_times"]; i++)
                negative_sequences.push(sequence);
        })
    }

    return negative_sequences;
}

function find_occurrences(line) {
    const occurrences = {};

    for (let i = 0; i < line.length; i++) {
        const num = line[i];

        if (occurrences[num]) {
            occurrences[num].push(i);
        } else {
            occurrences[num] = [i];
        }
    }

    const possible_negative_sequences = {};

    for (const num in occurrences) {
        if (occurrences[num].length > 2) {
            possible_negative_sequences[num] = occurrences[num];
        }
    }

    return possible_negative_sequences;
}

function increment_occurrences(negative_sequences, sequence, num_occurrences, subsequent_occurrences){
    if (subsequent_occurrences[sequence] == undefined){
        subsequent_occurrences[sequence] = {"rep_times": Math.floor(num_occurrences/3), "positions": negative_sequences[sequence] };
    } else {
        subsequent_occurrences[sequence]["rep_times"] += Math.floor(num_occurrences/3);
    }
}

function count_subsequent_occurrences(negative_sequences){
    const subsequent_occurrences = {};

    for (let sequence in negative_sequences){
        let sequences = negative_sequences[sequence];

        let num_occurrences = 1;
        for (let i = 1; i < sequences.length; i++){
            let isSubsequent = Math.abs(sequences[i-1]-sequences[i]) == 1;
            
            if (isSubsequent){
                num_occurrences += 1;
                
                if (i+1 == sequences.length) {
                    if (num_occurrences >= 3)
                        increment_occurrences(negative_sequences, sequence, num_occurrences, subsequent_occurrences);
                    num_occurrences = 1;
                }
            } else {
                if (num_occurrences >= 3)
                    increment_occurrences(negative_sequences, sequence, num_occurrences, subsequent_occurrences);
                num_occurrences = 1;
            }
        }
    }

    return subsequent_occurrences;
}

const identify_negative_sequences_position = (fullname) => {
    fullname = fullname.replaceAll(/\s/g, '').toLowerCase().split('');

    let kabbalistic_pyramid = [[]];
    fullname.forEach((char, idx, arr) => {
        kabbalistic_pyramid[0].push(sum_number(conversion_table[char]));
    });
    
    lines_to_compute = fullname.length - 1;
    
    for (let i = 0; i < lines_to_compute; i++){
        let lastIndex = kabbalistic_pyramid.length - 1;
        let current_line = kabbalistic_pyramid[lastIndex];
        let new_line_len = 0;
        let new_line = [];
        
        while(new_line_len < current_line.length - 1){
            let num = current_line[new_line_len] + current_line[new_line_len+1]
            new_line.push(sum_number(num));
            new_line_len += 1
        }
        
        kabbalistic_pyramid.push(new_line)
    }
    
    let lines = kabbalistic_pyramid.length;
    let repeated_numbers = {};
    
    for (let line = 0; line < lines; line++){
        let negative_seqs_occurrences = find_occurrences(kabbalistic_pyramid[line]);
        let subsequent_occurrences = count_subsequent_occurrences(negative_seqs_occurrences);

        if (Object.keys(subsequent_occurrences).length)
            repeated_numbers[`line${line+1}`] = subsequent_occurrences;
    }

    return repeated_numbers;
}

const handle_enter_key_submit = (event) => {
    let key = event.charCode || event.keyCode || 0;

    if (key == 13)
        event.preventDefault();
}

generate_pyramid();